import { fetchFromApi } from './fetchFromApi';

export const fetchUser = (userId: string) => fetchFromApi<{ name: string }>(`users/${userId}`);
